import React from "react";
import { connect } from "react-redux";
import "rc-slider/assets/index.css";
import {
  Input,
  Row,
  Col,
  Label,
  TabContent,
  FormGroup,
} from "reactstrap";
import JirangoCheckbox from "../../../../../components/UI/Checkbox/JirangoCheckbox";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import { deepClone } from "../../../../../helpers/objectHelper";
import CondtionTypeList from "../../../../areas/form/conditions/components/CondtionTypeList";
import { formActions } from "../../../../../store/actions/cms/form/form.action";
import ListExpansion from "../../../../../components/UI/ListExpansion/ListExpansion";
import JirangoSwitch from "../../../../../components/UI/Switch/JirangoSwitch";
import { ElementTabGroup } from "../../../../components/editor/tools/EditorTabGroup";
import { renderElementSettings } from "../../../../helpers/renderElementSettings";
import { toKebabCase } from "../../../../../helpers/cssHelper";
import ContentEditable from "react-contenteditable";


class EventSettings extends React.Component {
  state = { activeTab: new Array(2).fill('1'), isChange: false };
  componentDidMount() {
    this.setState({
      activeTab: new Array(2).fill('1'),
    });
  }
  handleSoftUpdate = (element) => {
    const { dispatch } = this.props;
    dispatch(formActions.updateFormElement(element));
  };
  handleSelectOnChange = (options, path) => {
    const names = path.split(".");
    const selectedElement = deepClone(this.props.selectedElement);
    selectedElement[names[0]][names[1]] = options.value;
    this.handleSoftUpdate(selectedElement);
  }

  toggle = (tabPane, tab) => {
    const newArray = this.state.activeTab.slice()
    newArray[tabPane] = tab
    this.setState({
      activeTab: newArray,
    });
  }
  handleChange = (e, val, path) => {
    const names = path.split(".");
    const element = deepClone(this.props.selectedElement);
    let value = null;
    if (val && val !== undefined) {
      value = val;
    }
    else if (e && e.target !== undefined && e.target.type === "checkbox") {
      value = e.target.checked;
    }
    else if (e && e.target !== undefined && e.target.type !== "checkbox") {
      value = e.target.value;
    }
    if (names.length === 2) {
      element[names[0]][names[1]] = value;
    }
    else if (names.length === 3) {
      element[names[0]][names[1]][names[2]] = !element[names[0]][names[1]][names[2]];
    }

    this.handleSoftUpdate(element);
  }
  updateConditions = (conditions) => {
    const element = Object.assign({}, this.state.element);
    element.data.conditions = conditions;
    this.setState({ element }, () => this.handleUpdate());
  }
  renderDisplaySettings = () => {
    const { selectedElement } = this.props;
    let ret = [];
    for (const key in selectedElement.data.display) {
      if (selectedElement.data.display.hasOwnProperty(key)) {
        const setting = selectedElement.data.display[key];
        ret.push(
          <Row key={key} >
            <Col className="list-setting-item-title col-adjusted">
              <JirangoCheckbox onChange={e =>
                this.handleChange(e, null, `data.display.${key}`)
              }
                inline={true}
                value={setting}
                type="info"
                labelName={`${key.charAt(0).toUpperCase() + key.substring(1)}`} />
            </Col>
          </Row>
        )
      }
    }
    return ret;
  }
  renderPropsSettings = () => {
    const { selectedElement } = this.props;
    let ret = [];

    const typeDic = {
      name: "text",
      startDateTime: "datetime-local",
      endDateTime: "datetime-local",
      description: "textarea",
      max: "number",
      amount: "number",
      city: "text",
      venue: "text",
      vatPercent: "number"
    }
    const widthDic = {
      name: "100%",
      startDateTime: "50%",
      endDateTime: "50%",
      description: "100%",
      max: "33.333%",
      amount: "33.333%",
      city: "100%",
      venue: "100%",
      vatPercent: "33.333%"
    }

    for (const key in selectedElement.props) {
      if (selectedElement.props.hasOwnProperty(key)) {
        const setting = selectedElement.props[key];
        if (key === 'isSelected') continue;
        ret.push(

          <Col key={key} style={{ flexBasis: 'unset', maxWidth: widthDic[key] }}>
            <FormGroup style={{ width: '100%' }}>
              <Label htmlFor="label"><SystemLabel name={`${key.charAt(0).toUpperCase() + key.substring(1)}`} /></Label>
              {typeDic[key] === 'textarea' ?
                <div className="styleWrapper"
                  style={
                    { width: "100%" }
                  }>
                  <style>
                    {`${toKebabCase(this.props.template.content, true)} `}
                  </style>
                  <ContentEditable
                    style={{
                      minHeight: '375px', border: '1px solid #e4e7ea',
                      padding: '0.375rem 0.75rem',
                      borderRadius: '3px',
                      overflowY: 'auto',
                      maxHeight: '375px'

                    }}
                    innerRef={this.contentEditable}
                    html={setting}
                    disabled={!this.props.cms.editMode}
                    onChange={e => this.handleChange(e, null, `props.description`)}
                    tagName="div"
                  />
                  <p
                    className="text-muted"
                    style={{ lineHeight: "initial", fontFamily: 'unset', letterSpacing: '0px', marginTop: "5px" }}
                  >
                    <SystemLabel name="ForMoreEditSettingsEventDesc" />
                  </p>
                </div> :
                <Input
                  autoComplete="jirango-nofill"
                  type={typeDic[key]}
                  className={typeDic[key] === 'number' ? 'number-w-textfacade' : ''}
                  style={{ minHeight: typeDic[key] === 'textarea' ? '375px' : 'initial' }}
                  value={setting ||""}
                  onChange={e => this.handleChange(e, null, `props.${key}`)}
                />}
            </FormGroup>
          </Col>
        )
      }
    }
    ret.push(
      <Col key={"x1"} style={{ flexBasis: 'unset', maxWidth: '100%' }}>
        <FormGroup style={{ width: '100%' }}>
          <Label htmlFor="location-label"><SystemLabel name={`LocationExpLabel`} /></Label>
          <Input
            id="location-label"
            autoComplete="jirango-nofill"
            value={selectedElement.data.locationLabel ? selectedElement.data.locationLabel : ''}
            onChange={e => this.handleChange(e, null, `data.locationLabel`)}
          />
        </FormGroup>
      </Col>
    )
    ret.push(
      <React.Fragment key={"x2"}>
        <Col key={"x3"} style={{ flexBasis: 'unset', maxWidth: '100%' }}>
          <FormGroup style={{ width: '100%' }}>
            <Label htmlFor="max-label"><SystemLabel name={`MaxAttendeeExpLabel`} /></Label>
            <Input
              id="max-label"
              autoComplete="jirango-nofill"
              value={selectedElement.data.maxLabel ? selectedElement.data.maxLabel : ''}
              onChange={e => this.handleChange(e, null, `data.maxLabel`)}
            />
          </FormGroup>
        </Col>
        <hr key={"x4"} />
      </React.Fragment>

    )
    return <Row style={{ margin: '-5px' }}>{ret.map(r => { return r })}</Row>;
  }
  handleSpaceOnChange = (e, path, dir) => {
    const names = path.split(".");
    const element = deepClone(this.props.selectedElement);
    const spaceValue = element[names[0]][names[1]];
    let value = e.target.value;
    let splitted = spaceValue.toString().split(' ')
    if (splitted.length > 1) {
      splitted[dir] = value + 'px';
      splitted = splitted.join(' ')
      element[names[0]][names[1]] = splitted;
    }
    else {
      let newString = `${splitted[0]}px ${splitted[0]}px ${splitted[0]}px ${splitted[0]}px`;
      newString = newString.split(' ');
      newString[dir] = value + 'px';

      element[names[0]][names[1]] = newString.join(' ');
    }
    this.handleSoftUpdate(element);
  }
  convertSpaceValue = (value, index) => {
    let splitted = value.toString().split(' ')
    if (splitted.length > 1) {
      return parseInt(splitted[index]);
    }
    else {
      return parseInt(splitted[0]);
    }
  }
  render() {
    const { selectedElement, selectedContainer, template, cms } = this.props;
    if (selectedElement === null) return null;
    return (
      <React.Fragment>
        <div>
          <ElementTabGroup activeTab={this.state.activeTab[0]} toggle={this.toggle} />
          <TabContent
            className="editor-tabcontent"
            style={{ paddingBottom: '65px' }}
            activeTab={
              this.state.activeTab[0]
            }
          >
            {this.state.activeTab[0] === "1" && (
              <React.Fragment>
                <ListExpansion footer={false} defaultExpanded={true} icon="fa fa-sticky-note" description="EventSettings">
                  {this.renderPropsSettings()}
                </ListExpansion>
                {selectedContainer ?
                  <React.Fragment>
                    <br />
                    {renderElementSettings(
                      selectedContainer.type,
                      selectedContainer,
                      this.props.toggleConditionModal
                    )}
                    <Row>
                      <Col style={{
                        marginLeft: '22px',
                        marginTop: '5px',
                        fontStyle: 'italic'
                      }} className="list-setting-item-title">
                        <p
                          className="text-muted"
                          style={{ lineHeight: "initial" }}
                        >
                          <SystemLabel name="ElementIsInContainerInfo" />
                        </p>
                      </Col>
                    </Row>
                  </React.Fragment>

                  : null}
              </React.Fragment>
            )}
            {this.state.activeTab[0] === "2" && (
              <ListExpansion
                footer={false}
                icon="fa fa-square"
                defaultExpanded={true}
                description="LayoutSettings"
              >
                <Row >
                  <Col className="list-setting-item-title">
                    <Label><SystemLabel name="Padding" /></Label>
                  </Col>
                </Row>
                <Row>
                  <Col className="list-setting-item-title" style={{ display: 'inline-flex' }}>
                    <div>
                      <Input
                        autoComplete="jirango-nofill"
                        type="number"
                        onChange={e => this.handleSpaceOnChange(e, `data.padding`, 0)}
                        value={this.convertSpaceValue(selectedElement.data.padding, 0)} />
                      <em><p style={{ textAlign: 'center' }} className="text-muted"><SystemLabel name="Top" /></p></em>
                    </div>
                    <div>
                      <Input
                        autoComplete="jirango-nofill"
                        type="number"
                        onChange={e => this.handleSpaceOnChange(e, `data.padding`, 1)}
                        value={this.convertSpaceValue(selectedElement.data.padding, 1)} />
                      <em><p style={{ textAlign: 'center' }} className="text-muted"><SystemLabel name="Right" /></p></em>
                    </div>
                    <div>
                      <Input
                        autoComplete="jirango-nofill"
                        type="number"
                        onChange={e => this.handleSpaceOnChange(e, `data.padding`, 2)}
                        value={this.convertSpaceValue(selectedElement.data.padding, 2)} />
                      <em><p style={{ textAlign: 'center' }} className="text-muted"><SystemLabel name="Bottom" /></p></em>
                    </div>
                    <div>
                      <Input
                        autoComplete="jirango-nofill"
                        type="number"
                        onChange={e => this.handleSpaceOnChange(e, `data.padding`, 3)}
                        value={this.convertSpaceValue(selectedElement.data.padding, 3)} />
                      <em><p style={{ textAlign: 'center' }} className="text-muted"><SystemLabel name="Left" /></p></em>
                    </div>
                  </Col>
                </Row>
                <Row >
                  <Col className="list-setting-item-title">
                    <Label><SystemLabel name="DescriptionMargin" /></Label>
                  </Col>
                </Row>
                <Row>
                  <Col className="list-setting-item-title" style={{ display: 'inline-flex' }}>
                    <div>
                      <Input
                        autoComplete="jirango-nofill"
                        type="number"
                        onChange={e => this.handleSpaceOnChange(e, `data.descriptionMargin`, 0)}
                        value={this.convertSpaceValue(selectedElement.data.descriptionMargin, 0)} />
                      <em><p style={{ textAlign: 'center' }} className="text-muted"><SystemLabel name="Top" /></p></em>
                    </div>
                    <div>
                      <Input
                        autoComplete="jirango-nofill"
                        type="number"
                        onChange={e => this.handleSpaceOnChange(e, `data.descriptionMargin`, 1)}
                        value={this.convertSpaceValue(selectedElement.data.descriptionMargin, 1)} />
                      <em><p style={{ textAlign: 'center' }} className="text-muted"><SystemLabel name="Right" /></p></em>
                    </div>
                    <div>
                      <Input
                        autoComplete="jirango-nofill"
                        type="number"
                        onChange={e => this.handleSpaceOnChange(e, `data.descriptionMargin`, 2)}
                        value={this.convertSpaceValue(selectedElement.data.descriptionMargin, 2)} />
                      <em><p style={{ textAlign: 'center' }} className="text-muted"><SystemLabel name="Bottom" /></p></em>
                    </div>
                    <div>
                      <Input
                        autoComplete="jirango-nofill"
                        type="number"
                        onChange={e => this.handleSpaceOnChange(e, `data.descriptionMargin`, 3)}
                        value={this.convertSpaceValue(selectedElement.data.descriptionMargin, 3)} />
                      <em><p style={{ textAlign: 'center' }} className="text-muted"><SystemLabel name="Left" /></p></em>
                    </div>
                  </Col>
                </Row>
              </ListExpansion>
            )}
            {this.state.activeTab[0] === "3" && (
              <div >
                <ListExpansion footer={false} defaultExpanded={true} icon="fa fa-sticky-note" description="DisplaySettings">
                  <Row>
                    <Col
                      className="list-setting-item-title"
                      style={{ display: "inline-flex" }}
                    >
                      <Label>
                        <SystemLabel name="HidePrice" />
                      </Label>
                    </Col>
                    <Col style={{ textAlign: "right", }}>
                      <JirangoSwitch
                        onChange={e => this.handleChange(e, null, `data.hidePrice`)}
                        isChecked={
                          selectedElement.data.hidePrice !== true
                            ? false
                            : true
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      className="list-setting-item-title"
                      style={{ display: "inline-flex" }}
                    >
                      <Label>
                        <SystemLabel name="ReadOnly" />
                      </Label>
                    </Col>
                    <Col style={{ textAlign: "right", }}>
                      <JirangoSwitch
                        onChange={e => this.handleChange(e, null, `data.readOnly`)}
                        isChecked={
                          selectedElement.data.readOnly !== true
                            ? false
                            : true
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      className="list-setting-item-title"
                      style={{ display: "inline-flex" }}
                    >
                      <Label>
                        <SystemLabel name="DoNotExistIfHidden" />
                      </Label>
                    </Col>
                    <Col style={{ textAlign: "right", maxWidth: '30%' }}>
                      <JirangoSwitch
                        onChange={e => this.handleChange(e, null, `data.doNotExistIfHidden`)}
                        isChecked={
                          selectedElement.data.doNotExistIfHidden !== true
                            ? false
                            : true
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col className="list-setting-item-title" style={{
                      marginTop: '5px',
                      fontStyle: 'italic'
                    }} className="list-setting-item-title">
                      <p
                        className="text-muted"
                        style={{ lineHeight: "initial",/*  marginTop: "5px" */ }}
                      >
                        <SystemLabel name="DoNotExistIfHiddenInfo" />
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      className="list-setting-item-title"
                      style={{ display: "inline-flex" }}
                    >
                      <Label>
                        <SystemLabel name="PreChecked" />
                      </Label>
                    </Col>
                    <Col style={{ textAlign: "right", }}>
                      <JirangoSwitch
                        onChange={e => this.handleChange(e, null, `data.preChecked`)}
                        isChecked={
                          selectedElement.data.preChecked !== true
                            ? false
                            : true
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      className="list-setting-item-title"
                      style={{ display: "inline-flex" }}
                    >
                      <Label>
                        <SystemLabel name="AllowOverbooking" />
                      </Label>
                    </Col>
                    <Col style={{ textAlign: "right", }}>
                      <JirangoSwitch
                        onChange={e => this.handleChange(e, null, `data.allowOverbooking`)}
                        isChecked={
                          selectedElement.data.allowOverbooking !== true
                            ? false
                            : true
                        }
                      />
                    </Col>
                  </Row>
                </ListExpansion>
                <br />
                <ListExpansion
                  footer={false}
                  icon="fa fa-square"
                  defaultExpanded={true}
                  description="RegistrationSettings"
                >
                  <Row>
                    <Col
                      className="list-setting-item-title"
                      style={{ display: "inline-flex" }}
                    >
                      <Label>
                        <SystemLabel name="ChangeLock" />
                      </Label>

                    </Col>
                    <Col style={{ textAlign: "right", }}>
                      <JirangoSwitch
                        onChange={e => this.handleChange(e, null, `data.changeLock`)}
                        isChecked={
                          selectedElement.data.changeLock !== true
                            ? false
                            : true
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col className="list-setting-item-title">
                      <p
                        className="text-muted"
                        style={{ lineHeight: "initial" }}
                      >
                        <SystemLabel name="ChangeLockInstruction" />
                      </p>
                    </Col>
                  </Row>
                </ListExpansion >
                <br />
                <ListExpansion
                  footer={false}
                  icon="fa fa-square"
                  description="Conditions"
                >
                  <CondtionTypeList
                    element={selectedElement}
                    toggleConditionModal={this.props.toggleConditionModal}
                  />
                </ListExpansion>
              </div>

            )}
          </TabContent>
        </div>
      </React.Fragment>

    );
  }
}

function mapStateToProps(state) {
  return {
    form: state.form,
    selectedElement: state.form.selectedElement,
    selectedContainer: state.form.selectedContainer,
    template: state.template.template,
    cms: state.cms
  };
}

export default connect(mapStateToProps)(EventSettings);
